export default __webpack_public_path__ + "static/media/shian.264a790c.jpg";